import { PropsWithChildren } from 'react'
import { useNavigation } from '@remix-run/react'
import FullPageLoading from '~/components/shared/FullPageLoading'

const NavigationLoading = (props: PropsWithChildren) => {
  const { children } = props
  const navigation = useNavigation()

  return (
    <>
      {navigation.state === 'loading' ? <FullPageLoading /> : null}
      {children}
    </>
  )
}

export default NavigationLoading
